import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { TournamentStatus } from '@/model/TournamentStatus'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'CTournamentStatusIndicator',
  props: {
    status: {},
    unstyled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props
const { t } = useI18n()

const show = computed(() => {
  return props.status === TournamentStatus.UPCOMING || props.status === TournamentStatus.RUNNING
})

const text = computed(() => {
  return t(`zoneSelection.zone.tournamentState_${props.status.toUpperCase()}`)
})

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_ctx.status, { 'tournament-status-indicator': !_ctx.unstyled }])
      }, _toDisplayString(text.value), 3))
    : _createCommentVNode("", true)
}
}

})